import {TypeVoie} from './TypeVoie';
export class TypeLieu {

	public ville: string;

	public voie: TypeVoie;

	public cp: string;

	constructor() { 
		 		this.ville = '';
		this.voie = new TypeVoie();
		this.cp = '';
 
	}
}
